import { createSetIntentType } from '../../intent';
export const onRender = createSetIntentType('onRender', (decorate)=>(render)=>{
        return decorate(render);
    });

//# sourceMappingURL=render.js.map